

/**
 * The friendly name of the current environment;
 */
export const friendlyName = 'Local Server';

/**
 * Id for this environment
 */
export const name = 'local';

/**
 * The domain base for the current environment
 */
export const scriptBase = window.location.origin + '/';

export const polyfillLocation = '/one-lni/v1/polyfills.js';

export const gatewayProxyUrl = '/one-lni/GatewayProxy/UiProxy.aspx?op=UiGatewayRestfulOperation';




// WEBPACK FOOTER //
// ./source/framework/instance/environment.js